import { Box } from 'grommet';
import React from 'react';

import { InventoryTable } from '../../components';

const Inventory = (): JSX.Element => {
  return (
    <Box pad={{ top: 'small' }} flex>
      <InventoryTable />
    </Box>
  );
};

export default Inventory;
